window.ShoppableLook = (function () {
  function formatMoney(cents, format) {
    cents = parseInt(cents, 10) || 0;
    var dollars = cents / 100;
    var noDecimals = Math.round(dollars).toString();
    var withComma = dollars.toFixed(2).replace(/\B(?=(\d{3})+(?!\d)\.)/g, ',');
    var noDecimalsComma = noDecimals.replace(/\B(?=(\d{3})+(?!\d)$)/g, ',');

    return (format || '${{amount}}')
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecimalsComma)
      .replace('{{amount_with_comma_separator}}', withComma)
      .replace('{{amount_no_decimals}}', noDecimals)
      .replace('{{amount}}', dollars.toFixed(2));
  }

  function init(sectionId) {
    var root = document.getElementById(sectionId);
    if (!root) return;

    var dots = root.querySelectorAll('[data-hotspot]');
    var rows = root.querySelectorAll('[data-row]');
    var popovers = root.querySelectorAll('[data-popover]');
    var addAllBtn = root.querySelector('[data-add-all]');
    var cartTotalEl = root.querySelector('[data-cart-total]');
    var moneyFormat = (window.Shopify && Shopify.money_format) || '${{amount}}';

    // True on devices that support real hover (desktop/mouse/trackpad).
    // On touch devices we fall back to tap-to-toggle instead.
    var supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    // When a hotspot is clicked/tapped it stays open ("pinned") even if the
    // mouse moves away, until the user clicks it again or clicks another dot.
    var pinnedTarget = null;

    function clearActive() {
      dots.forEach(function (d) { d.classList.remove('is-active'); });
      rows.forEach(function (r) { r.classList.remove('is-active'); r.classList.remove('is-dimmed'); });
      popovers.forEach(function (p) { p.classList.remove('is-visible'); });
    }

    function setActive(targetId, dot) {
      clearActive();
      dot.classList.add('is-active');
      rows.forEach(function (r) {
        if (r.id === targetId) {
          r.classList.add('is-active');
        } else {
          r.classList.add('is-dimmed');
        }
      });
      popovers.forEach(function (p) {
        if (p.getAttribute('data-popover') === targetId) {
          p.classList.add('is-visible');
        }
      });
    }

    dots.forEach(function (dot) {
      var targetId = dot.getAttribute('data-target');

      if (supportsHover) {
        // Show the product on hover / keyboard focus.
        dot.addEventListener('mouseenter', function () {
          setActive(targetId, dot);
        });
        dot.addEventListener('focus', function () {
          setActive(targetId, dot);
        });

        dot.addEventListener('mouseleave', function () {
          if (pinnedTarget !== targetId) clearActive();
        });
        dot.addEventListener('blur', function () {
          if (pinnedTarget !== targetId) clearActive();
        });

        // Click still pins it open (and scrolls the row into view) so the
        // person can move their mouse down to the product row / add button.
        dot.addEventListener('click', function () {
          if (pinnedTarget === targetId) {
            pinnedTarget = null;
            clearActive();
            return;
          }
          pinnedTarget = targetId;
          setActive(targetId, dot);
          var row = root.querySelector('#' + targetId);
          if (row) row.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      } else {
        // Touch devices: tap to toggle open/closed.
        dot.addEventListener('click', function () {
          var alreadyActive = dot.classList.contains('is-active');
          clearActive();
          if (alreadyActive) return;
          setActive(targetId, dot);
          var row = root.querySelector('#' + targetId);
          if (row) row.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      }
    });

    root.querySelectorAll('[data-variant-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var row = select.closest('[data-row]');
        var addBtn = row.querySelector('[data-add-to-cart]');
        var pricesJson = select.getAttribute('data-variant-prices');
        var prices = {};
        try { prices = JSON.parse(pricesJson) || {}; } catch (e) { prices = {}; }
        var newPrice = prices[select.value];

        if (addBtn) {
          addBtn.setAttribute('data-variant-id', select.value);
          if (typeof newPrice !== 'undefined') {
            addBtn.setAttribute('data-price', newPrice);
          }
        }

        var priceEl = row.querySelector('[data-row-price]');
        if (priceEl && typeof newPrice !== 'undefined') {
          priceEl.innerHTML = '<span>' + formatMoney(newPrice, moneyFormat) + '</span>';
        }

        updateCartTotal();
      });
    });

    function updateCartTotal() {
      if (!cartTotalEl) return;
      var total = 0;
      root.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
        total += parseInt(btn.getAttribute('data-price'), 10) || 0;
      });
      cartTotalEl.textContent = formatMoney(total, moneyFormat);
    }

    // Calculate the real total as soon as the section loads, instead of
    // leaving the button stuck on the server-rendered "0.00".
    updateCartTotal();

    root.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        addToCart(variantId, 1, btn);
      });
    });

    if (addAllBtn) {
      addAllBtn.addEventListener('click', function () {
        var items = [];
        root.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
          items.push({ id: btn.getAttribute('data-variant-id'), quantity: 1 });
        });
        addAllToCart(items, addAllBtn);
      });
    }

    function addToCart(variantId, quantity, btn) {
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          btn.textContent = 'Added';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1500);
        })
        .catch(function () {
          btn.textContent = 'Error, try again';
          btn.disabled = false;
        });
    }

    function addAllToCart(items, btn) {
      var originalText = btn.innerHTML;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          window.location.href = '/cart';
        })
        .catch(function () {
          btn.innerHTML = originalText;
          btn.disabled = false;
        });
    }
  }

  return { init: init };
})();